import React from "react";
import "../styles/Depoimentos.css";

const depoimentos = [
  {
    nome: "Dra. Camila Lopes",
    especialidade: "Ortodontista",
    frase: "O ARC me entregou clareza e resultados reais em poucas semanas. Nunca mais voltei para as planilhas!",
    foto: "https://randomuser.me/api/portraits/women/44.jpg"
  },
  {
    nome: "Dr. Ricardo Nunes",
    especialidade: "Clínico Geral",
    frase: "É como ter um gestor de negócios dentro do meu WhatsApp. Incrível!",
    foto: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    nome: "Dra. Larissa Almeida",
    especialidade: "Dermatologista",
    frase: "Simplesmente indispensável para quem quer crescer com inteligência e estratégia.",
    foto: "https://randomuser.me/api/portraits/women/68.jpg"
  },
  {
    nome: "Dra. Larissa Almeida",
    especialidade: "Dermatologista",
    frase: "Simplesmente indispensável para quem quer crescer com inteligência e estratégia.",
    foto: "https://randomuser.me/api/portraits/women/68.jpg"
  },
];

function Depoimentos() {
  return (
    <section className="depoimentos-section" id="clientes">
      <h2 className="depoimentos-title">O que dizem nossos clientes</h2>
      <div className="depoimentos-container">
        {depoimentos.map((item, index) => (
          <div className="depoimento-card" key={index}>
            <div className="depoimento-foto">
              <img src={item.foto} alt={item.nome} />
            </div>
            <p className="depoimento-frase">“{item.frase}”</p>
            <div className="depoimento-info">
              <strong>{item.nome}</strong>
              <span>{item.especialidade}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Depoimentos;
